export default {
    system: {
        main: 'Home',
        resident_portal: 'Dormitory Portal',
        tenant_portal: 'Tenant Portal',
        dorm: 'Dormitory',
        resident: 'Resident',
        tutor: 'Tutor | Tutors',
        profile: 'Profile | Profiles',
        account: 'Account',
        logout: 'Logout',
        login: 'Login',
        username: 'Username',
        new_username: 'New Username',
        password: 'Password',
        lastname: 'Lastname',
        firstname: 'Firstname',
        name: 'Name',
        phone: 'Phone',
        house: 'House',
        room: 'Room',
        common_rooms: 'Common Rooms',
        common_rooms_in_dorm: 'Common Rooms in Dorm',
        email: 'E-Mail Address',
        change_password: 'Change pssword',
        old_password: 'Old password',
        confirm_password: 'Confirm new password',
        new_password: 'New password',
        set_new_password: 'Set new password',
        provided_by_stuwe: 'data provided by Studierendenwerk',
        forgot_pw: 'Forgot username/password',
        request_pw_reset: 'Request password reset',
        pw_reset_with_token: '(Re)set password',
        manage_2fa: 'Manage two factor authentication',
        email_updated: 'E-Mail address updated',
        save: 'Save',
        password_reset_instructions: 'We sent you an email with further instructions. Please check your inbox.',
        tutors_in_dorm: 'Tutors in Dormitory',
        wifi_password: 'Personal Wi-Fi password',
        request_access: 'Request access',
        active: 'Active',
        discharge: 'Discharge',
        delete_assignment: 'Delete assignment',
        assign: 'Assign',
        assignment: 'Assignment',
        cancel: 'Cancel',
        actions: 'Actions',
        label: 'Label',
        card_id: 'Card ID',
        date_added: 'Date added',
        cards: 'Access cards',
        imprint: 'Imprint',
        privacy_policy: 'Privacy policy',
        tutor_responsible: "Responsible tutor",
        register: 'Register',
        semester_id: "Semester ID",
        semester_start: "Semester Start",
        semester_delete: "Delete Semester",
        winter_semester: "Winter Semester {year}",
        summer_semester: "Summer Semester {year}",
        activate_semester: "Activate semester",
        manage: 'Manage',
        read_more: "Read more",
        wifi: 'Wi-Fi',
        faq: 'FAQ',
        discharged: 'Discharged',
        tenant_name_or_room_number: 'Resident name oder room number',
        finish_assignment: 'Finish assignment',
        manage_common_room: 'Manage Common Room',
        add_card: 'Add card',
        lock_card: 'Lock card',
        unlock_card: 'Unlock card',
        card_locked: 'Card locked',
        internet_access: 'Internet Access',
        generate_token_link: 'Generate Password Reset/Onboarding Link',
        generate_activation: 'Generate Activation Link',
        tutor_admin: 'Tutor Administration',
        semester_admin: 'Semester Administration',
        admin_tutors: 'Admin Tutors',
        null: '',
        mpsk: 'SW-KA-IoT',
        mac: "MAC Address",
        delete_device: "Delete Device",
        close: "Close",
        toggle_pw: "Toggle Passwords",
        tutor_list_for: "List of tutors for the",
        tutor_type: "Type",
        tutor_name: "Name",
        tutor_room: "Room",
        tutor_mail: "E-Mail",
        tutor_phone: "Phone",
        generate_pdf: "Generate PDF",
        amount: "Amount",
        amt_new: "New Tutor Type",
        amt_edit: "Edit Tutor Type",
        amt_delete: "Delete",
        amt_label: "Name",
        amt_label_internal: "Internal Name",
        amt_sorting_order: "Sorting Order",
        amt_wikom: "Economic Comission",
        amt_can_modify_tutors: "May Modify Tutors",
        amt_community_manager: "Community Manager",
        update_changes: "Update Changes"
    },
    errors: {
        password_must_match: 'Passwords do not match.',
        password_must_not_empty: 'Password shall not be empty.',
        not_found: 'The requested resource was not found.',
        permission_denied: 'Thou shall not pass!',
        invalid_username: 'Invalid username. Valid characters are a-z, 0-9, _, -. No Spaces, only lower case letters.',
        no_resident_for_user: 'User is not assigned to a resident.',
        invalid_token: 'Invalid token.',
        username_is_not_set: 'Username is not yet set.',
        old_password_wrong: 'Current password is not correct.',
        unique_violation: 'Record already exists',
        invalid_room: 'Invalid room.',
        user_no_modify_rights: 'User has no modify-rights.',
        may_not_edit_semester_in_past: "You may not edit past semesters.",
        user_no_rights_on_target: "You have no rights on the target.",
        server_error: "Server error.",
        tenant_in_wrong_dorm: "Tenant is in the wrong dorm.",
        invalid_profile: "Invalid profile.",
        invalid_card: "Invalid card.",
        invalid_user: "Invalid user.",
        invalid_sensor: "Invalid sensor.",
        invalid_actuator: "Invalid actuator.",
        invalid_card_user_locked: "Invalid card - user is locked.",
        invalid_card_no_rights: "Invalid card - no rights.",
        semester_advance_non_monotonic: "Semesters before the current semester cannot be activated again.",
        invalid_login: 'Invalid credentials.',
        no_change: 'Nothing was changed.',
        invalid_psk: 'Invalid device password.',
        no_date_selected: 'No date selected.'
    }
}
